"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var TeamDetails_1 = __importDefault(require("containers/TeamView/TeamDetails"));
var analytics_1 = require("utils/analytics");
var populatedDerived_1 = require("utils/selectors/populatedDerived");
var single_1 = require("utils/selectors/single");
var WizardParts_1 = require("./WizardParts");
var TeamsDetailsWrapper = function (_a) {
    var team = _a.team;
    var serviceStatsArrayPop = (0, react_redux_1.useSelector)(populatedDerived_1.selectPopulatedServiceStats);
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var currentStep = react_1.default.useContext(WizardParts_1.TeamCreationWizardContext).currentStep;
    var _b = (0, react_final_form_1.useField)("emails.".concat(team.id), { subscription: { active: true, value: true } }), leadEmail = _b.input.value, emailFieldActive = _b.meta.active;
    var _c = (0, react_final_form_1.useField)('teams', { subscription: { value: true } }).input, teams = _c.value, onChange = _c.onChange;
    var firestore = (0, react_redux_firebase_1.useFirestore)();
    var depServices = serviceStatsArrayPop === null || serviceStatsArrayPop === void 0 ? void 0 : serviceStatsArrayPop.filter(function (sS) {
        var _a, _b, _c;
        return ((_a = sS.companyTeamIds) === null || _a === void 0 ? void 0 : _a.includes(team.id))
            || (((_b = sS.service) === null || _b === void 0 ? void 0 : _b.department) && ((_c = sS.service) === null || _c === void 0 ? void 0 : _c.department) === team.basedOn);
    });
    var track = (0, analytics_1.usePreparedTracker)('Add New Team');
    var removeTeam = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    track({ action: 'Remove from Preview', value: team.name, source: 'Onboarding' });
                    onChange(teams.filter(function (t) { return team.id !== t.id; }));
                    return [4 /*yield*/, firestore.collection('company_teams').doc(team.id).delete()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(TeamDetails_1.default, { team: team, teamLeadProfile: (myProfile.id === team.leaderId && myProfile), teamServices: depServices, isLeadPopupOpen: emailFieldActive, leadEmail: leadEmail, remove: currentStep === 'CREATE_TEAMS' && myProfile.companyTeamId !== team.id ? removeTeam : null }));
};
exports.default = react_1.default.memo(TeamsDetailsWrapper);
